import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReportManagementService {

  constructor(private rest: RestService) {

  }
  GetHistoricalReport(p: any): Observable<any> {
    return this.rest.get(`ManagementReport/GetHistoricalReport`, p);
  }
  GetTLROrphanReportExcel(p: any): Observable<any> {
    return this.rest.download(`TLRStatus/GetTLROrphanReportExcel`, p);
  }
  GetManagementReport(p: any): Observable<any> {
    return this.rest.post(`ManagementReport/GetManagementReport`, p);
  }
  GetManagementReportExcel(p: any): Observable<any> {
    return this.rest.downloadPost(`ManagementReport/GetManagementReportExcel?facilityId=${p.facilityId}&userCAI=${p.userCAI}&titleName=${p.titleName}`, {});
  }
  GetAgingReport(p: any): Observable<any> {
    return this.rest.get(`ManagementReport/GetAgingReport`, p);
  }
  GetAgingReportExcel(p: any): Observable<any> {
    return this.rest.download(`ManagementReport/GetAgingReportExcel`, p);
  }
  GetGreaterFiveYearReport(p: any): Observable<any> {
    return this.rest.get(`ManagementReport/GetGreaterFiveYearReport`, p);
  }
  GetGreaterFiveYearReportExcel(p: any): Observable<any> {
    return this.rest.download(`ManagementReport/GetGreaterFiveYearReportExcel`, p);
  }
  GetStewardshipReport(p: any): Observable<any> {
    return this.rest.get(`ManagementReport/GetStewardshipReport`, p);
  }
  GetStewardshipReportExcel(p: any): Observable<any> {
    return this.rest.download(`ManagementReport/GetStewardshipReportExcel`, p);
  }
}
